import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import NetPromotionScoreChart from './NetPromotionScoreChart';
const NetPromotionScore = () => {

    const [cargando, setCargando] = useState(false);
    const { setToken, token } = useToken();
    const { showErrorToast } = useToast();
    const [nps, setNps] = useState({
        total: 0,
        promoters: 0,
        passives: 0,
        detractors: 0,
        promotersPct: 0,
        passivesPct: 0,
        detractorsPct: 0
    });

    const ObtenerNetPromotionScore = async () => {
        setCargando(true);
        const response = await fetch("/api/soportetecnico/ObtenerNetPromotionScore/",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

        if (response.ok) {
            const data = await response.json();
            if (data && data.nps) {
                setNps({
                    total: data.nps.total || 0,
                    promoters: data.nps.promoters || 0,
                    passives: data.nps.passives || 0,
                    detractors: data.nps.detractors || 0,
                    promotersPct: data.nps.promotersPct || 0,
                    passivesPct: data.nps.passivesPct || 0,
                    detractorsPct: data.nps.detractorsPct || 0
                });
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
    };

    useEffect(() => {
        ObtenerNetPromotionScore();
    }, []);

    return (
        <Card className="card h-100">
            <FalconCardHeader
                title="Net Promotion Score 12 M"
                titleTag="h6"
                className="border-200 border-bottom py-2"
            />
            <Card.Body className="p-3 d-flex aligm-items-center">
                {cargando ? (
                    <div className="w-100">
                        <Skeleton height={200} />
                    </div>
                ) : (
                    <NetPromotionScoreChart nps={nps} />
                )}
            </Card.Body>
            <Card.Footer className="border-top border-200 py-0">
                <Row>
                    <Col className="border-end border-200 py-3 d-flex justify-content-center">
                        <div>
                            <h6 className="text-600 mb-1 fs--2">Promoters</h6>
                            <h6 className="fs-0 mb-0 d-flex align-items-center">
                                {cargando ? (
                                    <Skeleton width={60} />
                                ) : (
                                    <>
                                        {nps.promoters}
                                        <Badge
                                            pill
                                            bg="transparent"
                                            className="px-0 text-success d-flex align-items-start"
                                        >
                                            <FontAwesomeIcon
                                                icon="caret-up"
                                                className="fs--2 ms-2 me-1"
                                            />
                                            {nps.promotersPct}%
                                        </Badge>
                                    </>
                                )}
                            </h6>
                        </div>
                    </Col>
                    <Col className="border-end border-200 py-3 d-flex justify-content-center">
                        <div>
                            <h6 className="text-600 mb-1 fs--2">Passives</h6>
                            <h6 className="fs-0 mb-0 d-flex align-items-center">
                                {cargando ? (
                                    <Skeleton width={60} />
                                ) : (
                                    <>
                                        {nps.passives}
                                        <Badge
                                            pill
                                            bg="transparent"
                                            className="px-0 text-warning d-flex align-items-start"
                                        >
                                            <FontAwesomeIcon
                                                icon="minus"
                                                className="fs--2 ms-2 me-1"
                                            />
                                            {nps.passivesPct}%
                                        </Badge>
                                    </>
                                )}
                            </h6>
                        </div>
                    </Col>
                    <Col className="py-3 d-flex justify-content-center">
                        <div>
                            <h6 className="text-600 mb-1 fs--2">Detractors</h6>
                            <h6 className="fs-0 mb-0 d-flex align-items-center">
                                {cargando ? (
                                    <Skeleton width={60} />
                                ) : (
                                    <>
                                        {nps.detractors}
                                        <Badge
                                            pill
                                            bg="transparent"
                                            className="px-0 text-danger d-flex align-items-start"
                                        >
                                            <FontAwesomeIcon
                                                icon="caret-down"
                                                className="fs--2 ms-2 me-1"
                                            />
                                            {nps.detractorsPct}%
                                        </Badge>
                                    </>
                                )}
                            </h6>
                        </div>
                    </Col>
                </Row>
            </Card.Footer>
        </Card>
    );
};

NetPromotionScore.propTypes = {
};

export default NetPromotionScore;
